import { Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import Header from "../../components/Header/Header";
import TitleBand from "../../components/TitleBand/TitleBand";
import CtaBand from "../../components/Home/CtaBand";
import ContactForm from "../../components/Forms/ContactForm";
import ChatWidget from "../../components/ChatWidget/ChatWidget";
import CasesNav from "./CasesNav";
import CaseFeatured from "./CaseFeatured";
import CaseStory from "./CaseStory";
import CaseMedia from "./CaseMedia";
import CaseGroup from "./CaseGroup";
import { FEATURED_ID, MEDIA_ID, useCases } from "./CasesContent";
import { PageSeo } from "../../seo/Seo";
import "./Cases.css";

// Seções alternam branco e faixa clara (--band): destaque, cases em detalhe (faixa), na mídia e os temas.
export default function Cases() {
  const { t } = useTranslation();
  const { featured, stories, media, groups } = useCases();

  const shortcuts = [
    { id: FEATURED_ID, label: featured.title },
    ...stories.map((story) => ({ id: story.id, label: story.title })),
    { id: MEDIA_ID, label: t("cases_page.labels.media_short", "Na mídia") },
    ...groups.map((group) => ({ id: group.id, label: group.title })),
  ];

  return (
    <div className="cz-page cz-scope cz-cases-page">
      <PageSeo page="cases" path="/cases" />
      <Header />
      <main>
        <TitleBand
          title={
            <>
              {t("cases_page.hero.title_lead")}{" "}
              <span className="cz-cases-accent">{t("cases_page.hero.title_accent")}</span>
            </>
          }
          icon={Trophy}
          singleLine
        />
        <CasesNav links={shortcuts} />

        <CaseFeatured id={FEATURED_ID} featured={featured} />

        <div className="cz-cases-section cz-cases-section--band">
          <div className="cz-cases-section__inner cz-case-stories">
            {stories.map((story) => (
              <CaseStory key={story.id} story={story} />
            ))}
          </div>
        </div>

        <CaseMedia
          id={MEDIA_ID}
          title={t("cases_page.media.title")}
          text={t("cases_page.media.text")}
          items={media}
        />

        {groups.map((group, i) => (
          <CaseGroup key={group.id} group={group} index={i} band={i % 2 === 0} />
        ))}

        <CtaBand />
        <ContactForm />
      </main>
      <ChatWidget />
    </div>
  );
}
